module.exports = "<h1>Pagina non trovata</h1>\n\n<a href=\"/\">Torna alla home</a>\n"